import { Box, CircularProgress, Typography } from '@mui/material'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import Footer from '../Shared/Footer'
import SiteHeader from '../Shared/SiteHeader'

export const PrivacyPolicy = () => {
  const [content, setContent] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    axios
      .get('https://api.3knots.com/api/v1/cms/get-cms')
      .then((res) => setContent(res.data.data.privacyPolicy || ''))
      .catch(() => toast.error('Failed to load Privacy Policy. Please try again.'))
      .finally(() => setLoading(false))
  }, [])

  return (
    <div className='page-shell'>
      <SiteHeader />
      <Box className='page-content'>
        <Box className='page-container' sx={{ maxWidth: 800, mx: 'auto' }}>
          <Box className='section-header'>
            <Typography component='h1' className='section-title'>
              Privacy Policy
            </Typography>
          </Box>

          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
              <CircularProgress sx={{ color: '#ED1F24' }} />
            </Box>
          ) : (
            <Box
              sx={{ color: 'rgba(255,255,255,0.85)', lineHeight: 1.8 }}
              dangerouslySetInnerHTML={{ __html: content }}
            />
          )}
        </Box>
      </Box>
      <Footer />
    </div>
  )
}
